import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { twitterPageURL } from '../../util/urlHelpers';
import config from '../../config';
import {
  IconSocialMediaLinkedin,
  IconSocialMediaInstagram,
  IconSocialMediaTwitter,
  Logo,
  ExternalLink,
  NamedLink,
} from '../../components';

import css from './Footer.module.css';

const renderSocialMediaLinks = intl => {
  const { siteLinkedinPage, siteInstagramPage, siteTwitterHandle } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const goToLn = intl.formatMessage({ id: 'Footer.goToLinkedin' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });

  const LinLink = siteLinkedinPage ? (
    <ExternalLink key="linkToLinkedin" href={siteLinkedinPage} className={css.icon} title={goToLn}>
      <IconSocialMediaLinkedin />
    </ExternalLink>
  ) : null;

  const twitterLink = siteTwitterPage ? (
    <ExternalLink
      key="linkToTwitter"
      href={siteTwitterPage}
      className={css.icon}
      title={goToTwitter}
    >
      <IconSocialMediaTwitter />
    </ExternalLink>
  ) : null;

  const instragramLink = siteInstagramPage ? (
    <ExternalLink
      key="linkToInstagram"
      href={siteInstagramPage}
      className={css.icon}
      title={goToInsta}
    >
      <IconSocialMediaInstagram />
    </ExternalLink>
  ) : null;
  return [LinLink, twitterLink, instragramLink].filter(v => v != null);
};

const Footer = props => {
  const { rootClassName = null, className = null, intl } = props;
  const socialMediaLinks = renderSocialMediaLinks(intl);
  const classes = classNames(rootClassName || css.root, className);

  const goToFaveWeb = intl.formatMessage({ id: 'Footer.goToFaveWeb' });

  return (
    <div className={classes}>
      <div className={css.topBorderWrapper}>
        <div className={css.content}>
          <div className={css.links}>
            <div className={css.infoLinks}>
              <h4 className={css.sectionHeader}>
                <FormattedMessage id="Footer.buyerInfoHeader" />
              </h4>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <ExternalLink
                    key="linkToFaveWeb"
                    href={'https://faveforfans.com'}
                    title={goToFaveWeb}
                    name="FaveForFansWeb"
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.toAboutPage" />
                  </ExternalLink>
                </li>
                <li className={css.listItem}>
                  <ExternalLink
                    key="contactUsLink"
                    href={'mailto:marketplace@faveforfans.com'}
                    className={css.link}
                  >
                    <FormattedMessage id="Footer.toContactPage" />
                  </ExternalLink>
                </li>
                <li>
                  <NamedLink name="ReturnsPolicyPage" className={css.link}>
                    <FormattedMessage id="Footer.returnsPolicy" />
                  </NamedLink>
                </li>
              </ul>
            </div>

            <div className={css.infoLinks}>
              <h4 className={css.sectionHeader}>
                <FormattedMessage id="Footer.legalInfoHeader" />
              </h4>
              <ul className={css.list}>
                <li>
                  <NamedLink name="TermsOfServicePage" className={css.link}>
                    <FormattedMessage id="Footer.termsOfUse" />
                  </NamedLink>
                </li>
                <li>
                  <NamedLink name="PrivacyPolicyPage" className={css.link}>
                    <FormattedMessage id="Footer.privacyPolicy" />
                  </NamedLink>
                </li>
              </ul>
            </div>
            <div className={css.infoLinks}>
              <h4 className={css.sectionHeader}>
                <FormattedMessage id="Footer.sellerInfoHeader" />
              </h4>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <NamedLink name="FAQPage" className={css.link}>
                    <FormattedMessage id="Footer.toFAQPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="FAQPageSection"  params={{ section: 'returns' }} className={css.link}>
                    <FormattedMessage id="Footer.toReturnsAndRefundsPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="ShopSetupInstructionsPage" className={css.link}>
                    <FormattedMessage id="Footer.toShopSetupInstructionsPage" />
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="SellerOnboardingPage" className={css.link}>
                    <FormattedMessage id="Footer.toNewListingPage" />
                  </NamedLink>
                </li>
              </ul>
            </div>
            <div className={css.organization} id="organization">
              <NamedLink name="LandingPage" className={css.logoLink}>
                <Logo format="desktop" className={css.logo} />
              </NamedLink>
              <div className={css.organizationInfo}>
                <p className={css.organizationDescription}>
                  <FormattedMessage id="Footer.organizationDescription" />
                </p>
                <div className={css.someLinks}>{socialMediaLinks}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p className={css.organizationCopyright}>
            <NamedLink name="LandingPage" className={css.copyrightLink}>
              <FormattedMessage id="Footer.copyright" />
            </NamedLink>
          </p>
        </div>
      </div>
    </div>
  );
};


Footer.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
